import { FormattedMessage } from 'react-intl';
import {
  Checkbox,
  Col,
  Dropdown,
  Form,
  FormInstance,
  Row,
  Skeleton,
  Menu,
} from 'antd';

import {
  CompositionPriceFormInterface,
  CostItemField,
} from '@/core/domain/stock/Configuration/Configuration.types';
import { useCompanyFormContext } from '../../CompaniesFormProvider';
import { Info } from 'react-feather';

export interface CompanyStockPriceCompositionFormData {
  [x: string]: boolean | number;
  ipi: boolean;
  tax_replacement: boolean; // eslint-disable-line
  freight: boolean;
  accessory: boolean;
  fixed_cost: boolean; // eslint-disable-line
  icms: boolean;
  operational: boolean;
  fixedCostMargin: number;
  fixedProfitMargin: number;
}

interface CompanyStockPriceCompositionFormProps {
  form: FormInstance<CompositionPriceFormInterface>;
  isLoading: boolean;
}

function CompanyStockPriceCompositionForm({
  form,
  isLoading,
}: CompanyStockPriceCompositionFormProps) {
  const { formValues } = useCompanyFormContext();

  const informative = (
    <Menu mode="vertical" style={{ width: 300 }}>
      <Menu.Item key={1}>
        - Quando marcado a alteração incide sobre o PERCENTUAL DE LUCRO, o valor
        de venda é mantido e o percentual de lucro é alterado.
      </Menu.Item>

      <Menu.Item key={2}>
        - Quando desmarcado a alteração incide sobre o VALOR DE VENDA, o valor
        de venda é alterado e o percentual de lucro é mantido.
      </Menu.Item>
    </Menu>
  );

  return (
    <Form form={form} name="companyCompositionPrice">
      <Skeleton
        active
        loading={!formValues.companyCompositionPrice && isLoading}
      >
        <Row gutter={[16, 10]}>
          <Col span={24} style={{ marginBottom: '24px' }}>
            <Row gutter={[8, 8]}>
              {Object.values(CostItemField).map((costItemValue) => (
                <Col span={24} md={12} xl={8} key={costItemValue}>
                  <Form.Item
                    noStyle
                    name={costItemValue.substring(
                      costItemValue.lastIndexOf('.') + 1,
                    )}
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Checkbox>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <FormattedMessage
                          id={`companies.settings.priceComposition.${costItemValue}`}
                        />

                        {costItemValue ===
                        'domain.enums.item_field_calculate.profit_margin' ? (
                          <Dropdown
                            overlay={informative}
                            trigger={['click']}
                            arrow
                            placement="topCenter"
                          >
                            <Info
                              size={20}
                              id="note-type-icon"
                              cursor={'pointer'}
                            />
                          </Dropdown>
                        ) : undefined}
                      </div>
                    </Checkbox>
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Skeleton>
    </Form>
  );
}

export default CompanyStockPriceCompositionForm;
